import { Box } from "@mui/material";
import DataGridComponent from "../components/datagrid/datagrid.component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getRouterPaths } from "../router/routerPaths";
import { useCallback, useEffect, useRef, useState } from "react";
import { fetchCropsStart } from "../store/features/crops/cropsSlice";
import { getCultureActions } from "../utils/cultureUtils";
import CustomDialog from "../components/muiDialogs/dialog.component";
import { dialogMessages } from "../components/forms/utils";
import {
  deleteCultureStart,
  resetCreateCultureState,
  resetUpdateCultureState,
} from "../store/features/culture/cultureSlice";
import { useIsMobile } from "../hook/useIsMobile";
import {
  createCultureColumns,
  createCultureRowsData,
} from "../config/tables/cultureTable.config";

const CultureListPage = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchTimeoutRef = useRef();

  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedCulture, setSelectedCulture] = useState(null);
  const [selectedAction, setSelectedAction] = useState("");

  const type = useSelector((state) => state?.me?.data?.data?.type);
  const accessToken = useSelector((state) => state.auth?.user?.access_token);
  const cropsData = useSelector((state) => state.crops?.data?.data);
  const isCropsLoading = useSelector((state) => state.crops?.isLoading);
  const { success } = useSelector((state) => state.culture);

  const rows = cropsData?.map(createCultureRowsData);

  const routerPaths = getRouterPaths(type);
  const cultureActions = getCultureActions({
    navigate,
    routerPaths,
    setSelectedCulture,
    setSelectedAction,
    setDialogOpen,
  });

  const columns = createCultureColumns(cultureActions);

  const handleSearchChange = useCallback((value) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchTimeoutRef.current = setTimeout(() => {
      setSearchQuery(value);
    }, 500);
  }, []);

  const handleDialogConfirm = () => {
    if (selectedCulture) {
      dispatch(deleteCultureStart({ userId: selectedCulture, accessToken }));
      setDialogOpen(false);
      setSelectedCulture(null);
      setSelectedAction("");
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedCulture(null);
    setSelectedAction("");
  };

  useEffect(() => {
    if (type === "Admin") {
      dispatch(fetchCropsStart({ accessToken, search: searchQuery }));
    }
  }, [dispatch, type, accessToken, searchQuery]);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (success) {
      dispatch(resetCreateCultureState());
      dispatch(resetUpdateCultureState());
    }
  }, [dispatch, success]);

  return (
    <Box width="100%">
      <DataGridComponent
        rows={rows}
        columns={columns}
        inputPlaceholder="Cerca coltura"
        onSearchChange={handleSearchChange}
        marginTop={5}
        showButton
        buttonLabel={"Nuova coltura"}
        buttonHref={`/${type?.toLowerCase()}/cultureList/addCulture`}
        isMobile={isMobile}
        loading={isCropsLoading}
      />
      <CustomDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleDialogConfirm}
        title={dialogMessages.culture[selectedAction]?.title}
        description={dialogMessages.culture[selectedAction]?.description}
        confirmLabel={dialogMessages.culture[selectedAction]?.confirmLabel}
        actions={cultureActions}
      />
    </Box>
  );
};

export default CultureListPage;
